import MidiEffect from '../MidiEffect.js';
import Tone from 'tone';
import ParamMappable from './ParamMappable.js';
import ParamDisableable from "effects/midi/mappable/ParamDisableable.js";
import {AbstractParameter} from 'parameters/AbstractParameter.js';
import {setEffectParameterValues} from 'actions/index.js';
import {FORWARD, FORWARD_REVERSE, FORWARD_STAY} from 'constants/accumulator-modes.js';
import NodeMessaging from "messaging/NodeMessaging.js";

class ControlParametersEffect extends ParamDisableable(ParamMappable(NodeMessaging(MidiEffect))) {
    constructor(track) {
        super('Control Parameters', track);

        this.setupRampParameters();

        this.counter = -1;

        this.listParameter = new AbstractParameter(
            "list", this,
            () => [],
            {
                defaultValue: [0],
                min: 0,
                max: 1
            });

        this.registerParameter(this.listParameter);
        this.setupNodeMessaging();

        this.newInlet("list", (x) => this.onListMessage(x));
        this.newOutlet("value");
    }

    onListMessage(x) {
        this.listParameter.set(x[0]);
    }

    getText() { return ""; }
    
    set valueList(list) {
        this.listParameter.set([... list]);
    }

    get valueList() {
        return this.listParameter.get();
    }

    stop() {
        super.stop();
        this.counter = -1;
    }

    clear() {
        super.clear();
        this.counter = -1;
    }

    output(time, stepNumber) {
        if (!this.track.sequencerEngine.playing) {
            return this.triggers;
        }
        if (stepNumber === 0 && this.resetAtZero && this.counter !== 0) {
            this.stop();
            this._clear();
        }

        if (this.triggers.length === 0) {
            return this.triggers;
        }

        this.counter++;
        let value = this.valueList[this.counter % this.valueList.length];
        setTimeout(() => {
            this.sendMessage("value", value);
        }, (time - Tone.Master.context.currentTime)*1000);
        this.setParameterValues(time);
        return this.triggers;
    };

    getParameterValueToSet(i) {
        let value = this.valueList[this.counter % this.valueList.length];
        return this.initialParameterValues[i] + value * (this.getDepth(i) / 100.0);
    }

    getCopy(track, ignoreId=true) {
        let effect = new ControlParametersEffect(track);
        effect.fromJson(this.getJson(), ignoreId);
        return effect;
    }
}

export default ControlParametersEffect;


